/*eslint-disable*/ import type { Messages } from '@lingui/core';
export const messages = JSON.parse(
  '{"native.advertisement":"native.advertisement"}'
) as Messages;
